import { CommonModule } from '@angular/common';
import { Component, signal } from '@angular/core';
import { LoadingService } from '@core/service/loading.service';
import { Subscription } from 'rxjs';

@Component({
  standalone: true,
  selector: 'tmw-loading-spinner',
  template: `
    @if (isLoading()) {
      <div id="elmLoader">
        <div class="spinner-border text-primary avatar-sm" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    }
  `,
  imports: [CommonModule],
})
export class LoadSpinnerComponent {
  constructor(private loadingService: LoadingService) {}

  isLoading = signal(false);
  private subscription!: Subscription;

  ngOnInit(): void {
    // Subscribe to loading state changes
    this.subscription = this.loadingService.loadingSub.subscribe((loading: boolean) => {
      this.isLoading.set(loading);
    });
  }

  ngOnDestroy(): void {
    // Clean up subscription to prevent memory leaks
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
